/* apex-chrome.js — header mega menus and the mobile drawer.

   The triggers are server-rendered as real links to real pages. This file
   upgrades them to disclosures. If it never loads, Toolkits and Guides are
   still working navigation — there is no CSS :hover open rule anywhere, so a
   script failure cannot strand a half-open panel either. */
(function () {
  var nav = document.getElementById('apx-nav');
  var hdr = document.getElementById('apx-hdr');
  if (!hdr) return;

  /* ── mega menus ─────────────────────────────────────────────────────── */
  if (nav) {
    var items = [].slice.call(nav.querySelectorAll('[data-mega]'));
    var open = null, inT = null, outT = null;
    var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    function set(item, on) {
      item.classList.toggle('is-open', on);
      item.querySelector('.apx-nav__btn').setAttribute('aria-expanded', String(on));
      if (on) open = item; else if (open === item) open = null;
    }
    function closeAll() { items.forEach(function (i) { set(i, false); }); open = null; }

    items.forEach(function (item) {
      var trig = item.querySelector('.apx-nav__btn');
      trig.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (item.classList.contains('is-open')) set(item, false);
        else { if (open && open !== item) set(open, false); set(item, true); }
      });
      if (fine) {
        /* intent delay in, grace out: a cursor crossing the bar must not flash
           panels open, and a diagonal trip toward a row must not drop it */
        item.addEventListener('mouseenter', function () {
          clearTimeout(outT);
          inT = setTimeout(function () { if (open && open !== item) set(open, false); set(item, true); }, 110);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(inT);
          outT = setTimeout(function () { set(item, false); }, 220);
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { var t = open.querySelector('.apx-nav__btn'); closeAll(); t.focus(); }
    });
    document.addEventListener('click', function (e) { if (open && !open.contains(e.target)) closeAll(); });
    /* a panel left open while focus has moved past it is a keyboard trap */
    document.addEventListener('focusin', function (e) { if (open && !open.contains(e.target)) closeAll(); });
  }

  /* ── mobile drawer ──────────────────────────────────────────────────── */
  var burger = document.getElementById('apx-burger');
  var drw = document.getElementById('apx-drw');
  var scrim = document.getElementById('apx-scrim');
  if (burger && drw && scrim) {
    drw.hidden = false; scrim.hidden = false;   // hidden until JS, so no flash of an open drawer
    function setDrw(on) {
      burger.setAttribute('aria-expanded', String(on));
      drw.classList.toggle('is-on', on);
      scrim.classList.toggle('is-on', on);
      document.body.style.overflow = on ? 'hidden' : '';
    }
    burger.addEventListener('click', function () { setDrw(burger.getAttribute('aria-expanded') !== 'true'); });
    scrim.addEventListener('click', function () { setDrw(false); });
    drw.addEventListener('click', function (e) { if (e.target.closest('a[href]')) setDrw(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') { setDrw(false); burger.focus(); }
    });
    /* a drawer left open across a resize to desktop would lock body scroll */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 940 && burger.getAttribute('aria-expanded') === 'true') setDrw(false);
    });
  }

  /* ── stuck shadow ───────────────────────────────────────────────────── */
  var tick = false;
  function stuck() { tick = false; hdr.classList.toggle('is-stuck', window.scrollY > 4); }
  window.addEventListener('scroll', function () {
    if (tick) return; tick = true; requestAnimationFrame(stuck);
  }, { passive: true });
  stuck();
})();

/* ── scroll rails ─────────────────────────────────────────────────────────
   Drives .apx-rail: writes data-at so the CSS fades the end that still has
   content, and sizes the optional hairline under the row.

   Its own IIFE, not folded into the one above, because that one returns early
   when there is no header and a rail must not depend on the header existing.

   Everything here is progressive: the rail scrolls natively with or without
   this file. */
(function () {
  var rails = [].slice.call(document.querySelectorAll('.apx-rail'));
  if (!rails.length) return;

  rails.forEach(function (rail) {
    var wrap = rail.closest('.apx-rail__wrap');
    var bar = wrap && wrap.querySelector('.apx-rail__bar > i');
    var queued = false;

    function paint() {
      queued = false;
      var max = rail.scrollWidth - rail.clientWidth;
      /* above 749px the CSS drops the rail entirely and the row wraps, so
         there is no overflow and nothing should be marked */
      if (max < 4) {
        rail.removeAttribute('data-at');
        if (wrap) wrap.setAttribute('data-over', '0');
        return;
      }
      if (wrap) wrap.setAttribute('data-over', '1');
      var x = rail.scrollLeft;
      rail.setAttribute('data-at', x < 4 ? 'start' : (x > max - 4 ? 'end' : 'mid'));
      if (bar) {
        var frac = rail.clientWidth / rail.scrollWidth;
        bar.style.width = (frac * 100) + '%';
        /* translateX is a share of the bar's OWN width, so the travel is the
           track it does not occupy, expressed in those units */
        bar.style.transform = 'translateX(' + ((x / max) * (1 / frac - 1) * 100) + '%)';
      }
    }
    function queue() { if (queued) return; queued = true; requestAnimationFrame(paint); }

    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    /* fonts land after first paint and change every chip's width */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    paint();
  });

  /* A chip chosen with the arrow keys moves focus to a visually hidden radio
     parked at the top-left of the section, so the browser scrolls nothing and
     the chip you just selected can stay off-screen. Nudge the rail instead of
     calling scrollIntoView, which would also move the page vertically. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.id) return;
    var lb = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(t.id) : t.id) + '"]');
    var rail = lb && lb.closest('.apx-rail');
    if (!rail) return;
    var a = lb.getBoundingClientRect(), b = rail.getBoundingClientRect();
    /* Measured on the built theme: a scroll-snap container drops a smooth
       scroll entirely — scrollTo({behavior:'smooth'}) moved it 0px, and so did
       assigning scrollLeft once CSS scroll-behavior was smooth. A plain
       assignment with scroll-behavior left at auto is the one that lands. */
    if (a.left < b.left + 12) rail.scrollLeft += a.left - b.left - 24;
    else if (a.right > b.right - 12) rail.scrollLeft += a.right - b.right + 24;
  });
})();
